const _ = require('underscore');

const MediaDetail = require('../models/media/MediaDetail');

/**
 * Room filter model from Thunder with some Lighting logic
 * ref: OverDrive.Thunder.Models.GenericModels.RoomFilters
 */
class RoomFilters {
    constructor(props) {
        // All the properties are defined as List<string> thunder side ...
        this.subjects       = []; // 'int', 'int', etc.
        this.maturityLevels = []; // 'generalcontent', 'juvenile', 'youngadult', 'adultonly'
        this.language       = []; // 'en', 'gb', etc.
        this.mediaType      = []; // 'ebook', 'audiobook', 'video', 'periodicals'

        this._safeApply(props);

        // Made up numerical values so that we can do value based comparisons
        this._maturityLevelRank = {
            juvenile        : 100,
            youngadult      : 200,
            generalcontent  : 300,
            adultonly       : 400
        };
    }

    _safeApply(props) {
        let parameters = _.pick(props, _.keys(this));

        _.each(parameters, (value, key) => {
            if (value) {
                this[key] = _.isArray(value) ? value.slice() : [value];
            }
        });
    }

    /**
     * Returns passed collection of titles with only titles that meet the filter criteria
     * @param {MediaDetail[]} titles
     */
    filter(titles = []) {
        return titles.filter((title) => {
            return this._filterBySubject        (title, this.subjects)
                && this._filterByMaturityLevel  (title, this.maturityLevels)
                && this._filterByLanguage       (title, this.language)
                && this._filterByMediaType      (title, this.mediaType);
        });
    }

    _filterBySubject(title, subjectsToFilterBy = []) {
        let titleSubjects = _(title.subjects || []).pluck('id');

        return _(subjectsToFilterBy).isEmpty()
            || _(subjectsToFilterBy).every((filter) => _(titleSubjects).contains(filter));
    }

    _filterByLanguage(title, languagesToFilterBy = []) {
        let titleLanguages = _(title.languages || []).pluck('id');

        return _(languagesToFilterBy).isEmpty()
            || _(languagesToFilterBy).every((filter) => _(titleLanguages).contains(filter));
    }

    _filterByMediaType(title, mediaTypesToFilterBy = []) {
        return _(mediaTypesToFilterBy).isEmpty()
            || _(mediaTypesToFilterBy).contains(title.type.id);
    }

    // LHTNG-1547 - Maturity level is a a threshold check, not a set/contains match
    _filterByMaturityLevel(title, maturityLevelsToFilterBy = []) {
        if (_(maturityLevelsToFilterBy).isEmpty()) {
            return true; // No filter provided, approve the title
        }

        // Collect the maturityLevel assigned to the title
        let titleMaturityLevel = title.ratings.maturityLevel && title.ratings.maturityLevel.id || 'generalcontent';

        // Convert it to a numerical value we made up in this filter class
        let titleMaturityRank = _(this._maturityLevelRank).result(titleMaturityLevel, this._maturityLevelRank.generalcontent);

        // Find the minimum (youngest) audience that we are wanting to permit per the passed in filter
        let maturityFilterRanks = _(maturityLevelsToFilterBy).map((filter) => _(this._maturityLevelRank).result(filter, this._maturityLevelRank.generalcontent))

        // Where the title maturity is apropreate filters applied for the target room
        return titleMaturityRank <= _.max(maturityFilterRanks);
    }

    get hasMaturityLevelFilter() {
        return !_(this.maturityLevels).isEmpty();
    }
}

module.exports = RoomFilters;
